import { PushNotifications } from '@capacitor/push-notifications';
import api from './api';
import { Capacitor } from '@capacitor/core';

let isInitialized = false;

export const initPushNotifications = async () => {
    if (isInitialized) return;
    isInitialized = true;

    if (!Capacitor.isNativePlatform()) {
        return;
    }

    // Register with FCM
    await PushNotifications.register();

    // Request permission
    let permStatus = await PushNotifications.checkPermissions();
    if (permStatus.receive === 'prompt') {
        permStatus = await PushNotifications.requestPermissions();
    }
    if (permStatus.receive !== 'granted') {
        console.log('Push permission denied');
        return;
    }

    // Get token + send to backend
    PushNotifications.addListener('registration', async (token) => {
        console.log('Push token:', token.value);
        try {
            await api.post('/push/token', {
                token: token.value,
                platform: Capacitor.getPlatform()
            });
            console.log('Push token saved');
        } catch (err) {
            console.error('Failed to save push token', err);
        }
    });
};